export default {"src":"/_next/static/media/deposit.6cf0393d.svg","height":43,"width":79};